import { AfterViewInit, Component, ElementRef, Input, ViewChild, OnInit, ChangeDetectorRef } from '@angular/core';
import { setting } from '../../../../../../setting';

@Component({
  selector: 'usb-photos',
  templateUrl: './photos.component.html',
  styleUrls: ['./photos.component.scss']
})
export class PhotosComponent implements OnInit, AfterViewInit {
  @Input() images: any[] = [];
  @ViewChild('carouselTrack') carouselTrack!: ElementRef;

  duplicatedImages: any[] = [];
  currentIndex = 0;
  loading = false;
  public getClientsSettingAppBooking: any;
  private isLooping = false;
  private observer: IntersectionObserver | null = null;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.getClientsSettingAppBooking = JSON.parse(localStorage.getItem(setting.name));
    if (this.images.length > 0) {
      this.duplicatedImages = [...this.images, ...this.images, ...this.images];
      this.cdr.detectChanges();
    }
  }

  ngAfterViewInit() {
    if (this.images.length > 0) {
      setTimeout(() => {
        this.centerToRealImage(0);
        this.updateActiveIndex();
        this.setupIntersectionObserver();
      }, 100);
    }
  }


visibleDots: any[] = []; // ✅ Cache de dots
  private lastIndex = -1;
  private lastTotal = 0;

  // ✅ Función trackBy para que Angular reutilice los elementos DOM
  trackByDot(index: number, dot: any): string {
    return dot.isEllipsis ? `ellipsis_${index}` : `dot_${dot.index}`;
  }

  // ✅ Solo recalcular cuando realmente cambia
  updateVisibleDots(): void {
    const total = this.images.length;
    const current = this.currentIndex;

    // Si no hay cambios, salir
    if (this.lastTotal === total && this.lastIndex === current && this.visibleDots.length > 0) {
      return;
    }

    this.lastTotal = total;
    this.lastIndex = current;

    const dots = [];

    if (total <= 3) {
      for (let i = 0; i < total; i++) {
        dots.push({ index: i, label: (i + 1).toString(), isEllipsis: false, id: `dot_${i}` });
      }
      this.visibleDots = dots;
      return;
    }

    let startVisible: number;
    if (current <= 1) {
      startVisible = 0;
    } else if (current >= total - 2) {
      startVisible = total - 3;
    } else {
      startVisible = current - 1;
    }

    for (let i = 0; i < 3; i++) {
      const index = startVisible + i;
      if (index < total) {
        dots.push({ index: index, label: (index + 1).toString(), isEllipsis: false, id: `dot_${index}` });
      }
    }

    const lastIndex = total - 1;
    const lastVisible = dots[dots.length - 1]?.index;

    if (lastVisible < lastIndex) {
      dots.push({ index: -1, label: '...', isEllipsis: true, id: 'ellipsis_1' });
      dots.push({ index: lastIndex, label: (lastIndex + 1).toString(), isEllipsis: false, id: `dot_${lastIndex}` });
    }

    this.visibleDots = dots;
  }

  getVisibleDots(): any[] {
    this.updateVisibleDots();
    return this.visibleDots;
  }

  // Llamar updateVisibleDots cuando cambia currentIndex
  setCurrentIndex(index: number): void {
    if (this.currentIndex !== index) {
      this.currentIndex = index;
      this.updateVisibleDots();
    }
  }

  /**
   * Navegar a la imagen anterior (con loop)
   */
  prevImage(): void {
    if (this.loading) return;
    this.loading = true;

    let newIndex = this.currentIndex - 1;
    if (newIndex < 0) {
      newIndex = this.images.length - 1;
    }

    this.selectImage(newIndex);
    setTimeout(() => { this.loading = false; }, 300);
  }

  /**
   * Navegar a la siguiente imagen (con loop)
   */
  nextImage(): void {
    if (this.loading) return;
    this.loading = true;

    let newIndex = this.currentIndex + 1;
    if (newIndex >= this.images.length) {
      newIndex = 0;
    }

    this.selectImage(newIndex);
    setTimeout(() => { this.loading = false; }, 300);
  }

  setupIntersectionObserver() {
    const track = this.carouselTrack.nativeElement;

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.isLooping) {
          const slide = entry.target as HTMLElement;
          const slideIndex = parseInt(slide.dataset['index'] || '0');
          const realIndex = slideIndex % this.images.length;

          if (slideIndex <= 2) {
            this.isLooping = true;
            const targetIndex = slideIndex + this.images.length;
            const targetSlide = track.children[targetIndex] as HTMLElement;
            if (targetSlide) {
              track.scrollLeft = targetSlide.offsetLeft;
            }
            setTimeout(() => { this.isLooping = false; }, 100);
          } else if (slideIndex >= this.duplicatedImages.length - 3) {
            this.isLooping = true;
            const targetIndex = slideIndex - this.images.length;
            const targetSlide = track.children[targetIndex] as HTMLElement;
            if (targetSlide) {
              track.scrollLeft = targetSlide.offsetLeft;
            }
            setTimeout(() => { this.isLooping = false; }, 100);
          }
        }
      });
    }, { threshold: 0.5 });

    setTimeout(() => {
      const slides = track.querySelectorAll('.custom-carousel-slide');
      slides.forEach(slide => this.observer?.observe(slide));
    }, 100);
  }

  centerToRealImage(index: number) {
    if (this.carouselTrack && this.duplicatedImages.length > 0) {
      const realIndex = index % this.images.length;
      const targetIndex = realIndex + this.images.length;
      const slides = this.carouselTrack.nativeElement.children;
      if (slides[targetIndex]) {
        slides[targetIndex].scrollIntoView({
          behavior: 'auto',
          block: 'nearest',
          inline: 'center'
        });
        this.currentIndex = realIndex;
        this.cdr.detectChanges();
      }
    }
  }

  updateActiveIndex() {
    if (this.carouselTrack && this.carouselTrack.nativeElement && !this.isLooping) {
      const track = this.carouselTrack.nativeElement;
      const slides = track.children;
      const trackCenter = track.scrollLeft + (track.clientWidth / 2);

      let closestIndex = 0;
      let closestDistance = Infinity;

      for (let i = 0; i < slides.length; i++) {
        const slide = slides[i] as HTMLElement;
        const slideCenter = slide.offsetLeft + (slide.offsetWidth / 2);
        const distance = Math.abs(trackCenter - slideCenter);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = i;
        }
      }

      const newIndex = closestIndex % this.images.length;
      if (newIndex !== this.currentIndex) {
        this.currentIndex = newIndex;
        this.cdr.detectChanges();
      }
    }
  }

  selectImage(index: number) {
    if (this.carouselTrack && this.duplicatedImages.length > 0) {
      const targetIndex = index + this.images.length;
      const slides = this.carouselTrack.nativeElement.children;
      if (slides[targetIndex]) {
        slides[targetIndex].scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
        this.currentIndex = index;
        this.cdr.detectChanges();
      }
    }
  }

  onScroll() {
    this.updateActiveIndex();
  }
}
